import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import { ROLE } from "../../config/business";
import ForgetPass from "./ForgetPass";
import VerifyForm from "./VerifyForm";

function ForgetPassLayout(props) {

  const [otpData, setotpData] = useState({
    forgetPass: {
        custId: "",
        role: ROLE[0].value,
        email: "",
        phone: "",
        otpInfo: {
          otpTimeout: 0,
          otpExpired: "",
          encryptedOTP: ""
        }
      },
    verifyForm: {
        reqId: "",
        otp: "",
        otpTimeout: 0,
        encryptedOTP: "",
        otpExpired: 0,
        otpTimeout: 0,
        otpTimeoutStr: ""
    },
    check: false,
    loading: false,
    message: {
        title: "",
        content: ""
    }
  });

  const updateOtpData = async (obj) => {
    setotpData({ 
        ...otpData,
        verifyForm : {
            otp: obj.verifyForm.otp,
            otpTimeout: obj.verifyForm.otpTimeout,
            encryptedOTP: obj.verifyForm.encryptedOTP,
            otpExpired: obj.verifyForm.otpExpired
        }
    })
  }

  return <div>
      {otpData.check? <VerifyForm otpData={otpData} props={{...props}} setotpData={setotpData} ></VerifyForm> : <ForgetPass updateOtpData={updateOtpData} otpData={otpData} props={{...props}} setotpData={setotpData}></ForgetPass> }
      {otpData.loading && <LoadingSpinner/> }
  </div>;
}

export default ForgetPassLayout;
